import { API } from "aws-amplify";
import * as APITypes from "~/API";
import { createMonthlyStatusReport } from "~/graphql/mutations";
import { LoaderData } from "~/types";

const EMPTY_MONTHLY_STATUS: APITypes.MonthlyStatusReport = {
  __typename: "MonthlyStatusReport",
  id: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  month: 0,
  year: 0,
  createdAt: "",
  updatedAt: "",
  numOccupied: 0,
  numVacant: 0,
  numRenovation: 0,
  expectedRent: 0,
  expectedStayRevenue: 0,
  aggregateIncome: {
    __typename: "IncomeStatement",
    rentRevenue: 0,
    stayRevenue: 0,
    feeRevenue: 0,
    otherRevenue: 0,
    totalRevenue: 0,
    repairExpenses: 0,
    lostRentExpenses: 0,
    renovationExpenses: 0,
    totalExpenses: 0,
    net: 0,
    ownerID: "",
    ownerType: APITypes.OwnerType.User,
  },
  numUnits: 0,
  numBuildings: 0,
  numProperties: 0,
  numServiceRequests: 0,
  numAmenities: 0,
  numAmenityReservations: 0,
  _version: 0,
  _lastChangedAt: 0,
};

export const addMonthlyStatusDetails = async (
  payload: APITypes.CreateMonthlyStatusReportInput
): Promise<LoaderData<APITypes.MonthlyStatusReport>> => {
  try {
    const response = (await API.graphql({
      query: createMonthlyStatusReport,
      variables: {
        input: payload,
      },
    })) as { data?: APITypes.CreateMonthlyStatusReportMutation };

    return {
      success: true,
      data: response.data?.createMonthlyStatusReport || EMPTY_MONTHLY_STATUS,
    };
  } catch (error) {
    console.error("Error adding monthly status", payload.id, "error", error);
    return {
      success: false,
      data: EMPTY_MONTHLY_STATUS,
      error,
    };
  }
};
